// Iter-207p — Unified "Invoice reminders hub" tabbed wrapper.
// Hosts the 3 reminder-related screens previously scattered in Finance ▸
// Facturation clients (Reminders audit · Invoice reminders · Invoice email
// template) as Tabs so the CEO can configure + audit them in one place.
import React, { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import InvoiceRemindersAudit from "./InvoiceRemindersAudit";
import InvoiceRemindersSettings from "./settings/InvoiceRemindersSettings";
import MaintenanceSettings from "./settings/MaintenanceSettings";
import { Mail, Calendar, Activity } from "lucide-react";

export default function InvoiceRemindersHub() {
  const [tab, setTab] = useState("schedule");
  return (
    <div className="p-6 max-w-7xl mx-auto" data-testid="invoice-reminders-hub-page">
      <header className="mb-5 space-y-1">
        <h1 className="text-2xl font-light tracking-tight">Invoice reminders</h1>
        <p className="text-sm text-zinc-600 max-w-3xl leading-relaxed">
          Configuration et audit des relances automatiques sur les factures clients : planning des envois, gabarit d'email d'envoi, et historique des relances envoyées.
        </p>
      </header>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4">
          <TabsTrigger value="schedule" data-testid="invoice-reminders-tab-schedule" className="flex items-center gap-2">
            <Calendar size={14} /> Planning des relances
          </TabsTrigger>
          <TabsTrigger value="email" data-testid="invoice-reminders-tab-email" className="flex items-center gap-2">
            <Mail size={14} /> Gabarit email d'envoi
          </TabsTrigger>
          <TabsTrigger value="audit" data-testid="invoice-reminders-tab-audit" className="flex items-center gap-2">
            <Activity size={14} /> Audit des relances envoyées
          </TabsTrigger>
        </TabsList>
        <TabsContent value="schedule" className="mt-0">
          <div className="-mx-6 -mb-6"><InvoiceRemindersSettings /></div>
        </TabsContent>
        <TabsContent value="email" className="mt-0">
          <div className="-mx-6 -mb-6"><MaintenanceSettings section="invoice-email" /></div>
        </TabsContent>
        <TabsContent value="audit" className="mt-0">
          <div className="-mx-6 -mb-6"><InvoiceRemindersAudit /></div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
